import { AuthContext } from '@features/auth/components/AuthContext'
import { useContext } from 'react'

export const useAuthenticator = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuthenticator must be used within an AuthProvider')
  }

  return context
}
